'use client';

import { ReactNode } from 'react';

import { DraftModeProvider } from '@natu/storyblok/DraftModeProvider';
import { ReactQueryProvider } from '@natu/storyblok/ReactQueryProvider';
import { GooglePageView, GoogleTagManager } from '@natu/storyblok/third-party-integration';
import { CustomCursorProvider } from '@natu/ui/Decorators/CustomCursor';

interface ProvidersProps {
  gtmId?: string;
  children?: ReactNode;
  draftMode?: boolean;
}

export const Providers = ({ children, draftMode, gtmId }: ProvidersProps) => (
  <ReactQueryProvider>
    <CustomCursorProvider>
      <DraftModeProvider draftMode={draftMode}>
        {!draftMode && <GoogleTagManager gtmId={gtmId} />}
        {children}
        <GooglePageView />
      </DraftModeProvider>
    </CustomCursorProvider>
  </ReactQueryProvider>
);
